export default __webpack_public_path__ + "static/media/search.64d00841.svg";